export default __webpack_public_path__ + "img/ledger-icon.d5d0f872.svg";